import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 查询列筛选方案
export const QUERY_FILTER = (type: string) =>
  GET(`${HTTP}/screeningScheme/query`, { type })

// 保存/更新列筛选方案
export const SAVE_FILTER = (params: any) =>
  POST(`${HTTP}/screeningScheme/saveOrUpdate`, params, 'application/json')
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 查询列筛选方案
export const QUERY_FILTER = (type: string) =>
  GET(`${HTTP}/screeningScheme/query`, { type })

// 保存/更新列筛选方案
export const SAVE_FILTER = (params: any) =>
  POST(`${HTTP}/screeningScheme/saveOrUpdate`, params, 'application/json')
